import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../utils/translations';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {IconBullet} from '../IconBullet/IconBullet';
import edap from '@homeaway/edap-wrapper';
import AbacusClientUtils from '@homeaway/abacus-client-utils';

export class CancelProtection extends React.PureComponent {
    static propTypes = {
        cancelCtaLink: PropTypes.string,
        eventAction: PropTypes.string.isRequired,
        eventCategory: PropTypes.string.isRequired,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        eventCategory: 'traveler activity',
        eventAction: 'add.cancel.protection.clicked',
        translations: {},
    };

    vasNameUpdate = () => {
        const vasNameBucket =
            AbacusClientUtils.evaluateExperimentAndLog('vasnameupdatev2');
        return vasNameBucket?.value === 1
            ? translate(
                  this.props.translations,
                  'trav-dash/trav-home',
                  'messages',
                  'th.confirmation.cancel.cta.update'
              )
            : translate(
                  this.props.translations,
                  'trav-dash/trav-home',
                  'messages',
                  'th.confirmation.cancel.cta'
              );
    };

    onClickCancelProtection = () => {
        edap().push({
            name: 'generic.click',
            data: {
                eventaction: this.props.eventAction,
                eventcategory: this.props.eventCategory,
            },
        });
    };

    render() {
        const {cancelCtaLink, translations} = this.props;

        if (!cancelCtaLink) {
            return null;
        }

        return (
            <div className="CancelProtection hidden-print">
                <h3 className="text-center">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.cancel.title'
                    )}
                </h3>
                <p className="text-center">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.cancel.text'
                    )}
                </p>
                <ul
                    role="presentation"
                    aria-live="off"
                    aria-label={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.aria.label'
                    )}
                    className="list-unstyled list--vertical-grid"
                >
                    <IconBullet
                        text={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.confirmation.cancel.reason1'
                        )}
                    />
                    <IconBullet
                        text={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.confirmation.cancel.reason2'
                        )}
                    />
                    <IconBullet
                        text={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.confirmation.cancel.reason3'
                        )}
                    />
                </ul>
                <div className="text-center">
                    <ButtonPrimary
                        className={'btn--nowrap'}
                        href={cancelCtaLink}
                        label={this.vasNameUpdate()}
                        onClick={this.onClickCancelProtection}
                    />
                </div>
            </div>
        );
    }
}
